import { render, staticRenderFns } from "./CheckApprovalStatus.vue?vue&type=template&id=4a2bd984&scoped=true&"
import script from "./CheckApprovalStatus.vue?vue&type=script&lang=js&"
export * from "./CheckApprovalStatus.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=4a2bd984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2bd984",
  null
  
)

export default component.exports